var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OptionsDisplay',_vm._g(_vm._b({attrs:{"value":_vm.value,"fields":_vm.fields}},'OptionsDisplay',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }